var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 12.6429C3.61111 12.6429 2.5 13 2.5 14.4286C2.5 15.8571 3.61111 16.2143 4.16667 16.2143H15.8333C16.3889 16.2143 17.5 15.8571 17.5 14.4286C17.5 13 16.3889 12.6429 15.8333 12.6429M4.16667 12.6429C4.30556 11.4524 4.66667 9.33929 5 8.625C5.58202 7.06601 6.97704 6.16033 8.33333 5.75585M4.16667 12.6429H5.83333M15.8333 12.6429C15.8333 11.6012 15.6229 9.62609 15 8.625C14.03 7.06601 12.8295 6.16033 11.5975 5.75585M15.8333 12.6429H14.1667M8.33333 5.75585C8.91897 5.5812 9.49738 5.5 10 5.5C10.5277 5.5 11.0655 5.5812 11.5975 5.75585M8.33333 5.75585V10.4107M11.5975 5.75585V10.4107",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.9bd171da9027358f5de91323ab4366ee.svg";
export { ForwardRef as ReactComponent };